import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: HomeView
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
